import React, { Component } from "react";
import PropTypes from "prop-types";

/**
 * each RowCard will display the given columns in a row,
 * calculating the spacing based on the number of items in this.props.columns.
 *
 *
 * let exampleColumns = [
 *  {
 *     text: 'first col',
 *     style: {color: 'red', fontSize: '14px'}
 *  },
 *  {
 *     text: 'second col'
 *  },
 *  {
 *     text: 'third col'
 *  },
 * ]
 *
 * */
export default class RowCard extends Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      collapsed: !props.expanded,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.expanded !== prevProps.expanded) {
      this.setState({ collapsed: !this.props.expanded });
    }
  }

  renderColumns() {
    let colSpacing = Math.round(100 / this.props.columns.length);
    return this.props.columns.map((item, index) => {
      return (
        <span
          className={`column ${
            item.columnWidth ? "column-" + item.columnWidth : ""
          }`}
          style={item.style || {}}
          key={`${btoa(Math.random().toString())}_${index}`}
        >
          {!!item.title && <p className={"row-column-title"}>{item.title}</p>}
          <p className={"row-column-content"} style={item.textStyle || {}}>
            {item.html ? (
              item.html
            ) : (
              <span>
                {item.icon}
                {item.icon && " "}
                {item.text}
              </span>
            )}
          </p>
        </span>
      );
    });
  }

  render() {
    return (
      <div
        className={`card row-card ${this.props.className}`}
        style={
          this.props.color
            ? { borderLeft: `3px solid ${this.props.color}` }
            : { ...this.props.style }
        }
        onClick={this.props.onClick ? this.props.onClick : () => null}
      >
        {!!this.props.onRemove && (
          <i
            onClick={this.props.onRemove}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              opacity: 0.8,
              cursor: "pointer",
            }}
            className={"far fa-times-circle"}
          />
        )}
        <div className="row">
          <div
            className={`column ${this.props.actionButton ? "column-80" : ""}`}
          >
            <div className={"row"}>
              {this.props.children && (
                <i
                  onClick={() => {
                    this.setState({ collapsed: !this.state.collapsed });
                  }}
                  className={`fas ${
                    this.state.collapsed
                      ? "fas fa-caret-right"
                      : "fas fa-caret-down"
                  }`}
                />
              )}
              {this.renderColumns()}
            </div>
          </div>
          {!!this.props.actionButton && (
            <div className={"column column-20 justify-end"}>
              {this.props.actionButton}
            </div>
          )}
        </div>
        {!this.state.collapsed && this.props.children}
      </div>
    );
  }
}
